import { CampaignIndustry } from '../types';

export interface IndustryBenchmark {
  resultLabel: string;
  estimatedRange: string;
  optimizationWindow: string;
}

/** نطاقات تخطيط أولية للسوق المصري وليست بيانات حية أو ضماناً للنتيجة. */
export const INDUSTRY_BENCHMARKS: Record<CampaignIndustry, IndustryBenchmark> = {
  real_estate: { resultLabel: 'عميل محتمل', estimatedRange: '250–1,200 EGP', optimizationWindow: '14–21 يومًا' },
  ecommerce: { resultLabel: 'شراء أو نتيجة', estimatedRange: '60–220 EGP', optimizationWindow: '7–14 يومًا' },
  professional_services: { resultLabel: 'عميل محتمل', estimatedRange: '150–500 EGP', optimizationWindow: '10–14 يومًا' },
  education: { resultLabel: 'تسجيل أو عميل محتمل', estimatedRange: '100–350 EGP', optimizationWindow: '10–14 يومًا' },
  healthcare: { resultLabel: 'حجز أو عميل محتمل', estimatedRange: '180–550 EGP', optimizationWindow: '10–14 يومًا' },
  restaurants: { resultLabel: 'طلب أو حجز', estimatedRange: '25–100 EGP', optimizationWindow: '7–10 أيام' },
  automotive: { resultLabel: 'حجز أو عميل محتمل', estimatedRange: '220–700 EGP', optimizationWindow: '14–21 يومًا' },
  tourism: { resultLabel: 'حجز أو عميل محتمل', estimatedRange: '180–650 EGP', optimizationWindow: '14–21 يومًا' },
  fitness: { resultLabel: 'اشتراك أو عميل محتمل', estimatedRange: '90–350 EGP', optimizationWindow: '10–14 يومًا' },
  mobile_apps: { resultLabel: 'تسجيل أو اشتراك', estimatedRange: '70–400 EGP', optimizationWindow: '7–14 يومًا' },
};
